// extracted by mini-css-extract-plugin
module.exports = {"container":"html-description-withShowMoreInMobile-container-ec0cb3b1","toggle":"html-description-withShowMoreInMobile-toggle-e27ee48f"};